@if (cardInfo(); as cardInfo) {
  <div>
    <crm-collapsible-section [maxHeightPx]="100">
      <!-- Show summaryBody (like noteBody) if summaryTitle exists, otherwise show body -->
      @if (cardInfo.summaryTitle && cardInfo.summaryBody) {
        <crm-activity-rich-text [richText]="cardInfo.summaryBody"></crm-activity-rich-text>
      } @else {
        <crm-activity-rich-text [richText]="cardInfo.body"></crm-activity-rich-text>
      }
      @if (cardInfo.activityUrl) {
        <div class="link">
          <a [href]="cardInfo.activityUrl">{{ cardInfo.activityUrlName || cardInfo.activityUrl }}</a>
        </div>
      }
    </crm-collapsible-section>
    <div class="row">
      <ng-container
        [ngTemplateOutlet]="activityData"
        [ngTemplateOutletContext]="{ label: 'ACTIVITY.COMMUNICATION.TYPE', value: cardInfo.channel }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="activityData"
        [ngTemplateOutletContext]="{ label: 'ACTIVITY.OUTCOME', value: cardInfo.outcome }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="activityData"
        [ngTemplateOutletContext]="{ label: 'ACTIVITY.DATE', value: cardInfo.date | date: dateFormat }"
      ></ng-container>
    </div>
  </div>
}

<ng-template #activityData let-label="label" let-value="value">
  <div class="col col-xs-12 col-md-4">
    <div class="activity-data-label">
      {{ label | translate }}
    </div>
    <div class="activity-data-value">
      <!-- ng-container necessary so angular interpolation will add empty -->
      @if (value) {
        {{ value }}
      }
    </div>
  </div>
</ng-template>
